export enum PflegiaEmployeeEmploymentType {
  FullTime = 'full_time',
  PartTime = 'part_time',
  Intern = 'intern',
}
